import * as React from 'react';
import { baseApiRoute } from 'src/resources/const';
import { TrixEditor } from 'react-trix';

export interface RichEditComponentProps {
    id: string;
    value?: string;
    placeholder?: string;
    disabled: boolean;
    uploadURL: string;
    onChange: (html: string, text: string) => void;
}

let mergeTags = [{
    trigger: '@',
    tags: [
    ]
}, {
    trigger: '{',
    tags: [
    ]
}];

const RichEditComponent = (props: RichEditComponentProps) => {

    return (
        <TrixEditor
            onChange={props.onChange}
            mergeTags={mergeTags}
            autoFocus={true}
            placeholder={props.placeholder}
            uploadURL={baseApiRoute + '/save-image'}
            value={props.value}
        />
    );
};

export default RichEditComponent;



// WEBPACK FOOTER //
// ./src/modules/commons/inputs/rich-edit/RichEdit.component.tsx